<template>
  <div class="table-container w-100 overflow-auto">
    <slot></slot>
  </div>
</template>

<script setup>

</script>

<style scoped>

</style>
